import { memo } from 'react';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';
import { useSelector } from 'react-redux';
import { OBJECT_TYPE } from 'src/constants';
import { IContent } from 'src/interface';
import { useModal } from 'src/hooks/useModal';
import { isOpenSelector } from 'src/selectors/content';
import { isMiniappSelector } from 'src/selectors/app';
import { Element, Icon, IconButton } from 'src/components';
import BookmarkButton from 'src/modules/shared/components/buttons/BookmarkButton';
import FollowButton from 'src/modules/shared/components/buttons/FollowButton';
import ReportButton from '../../ContentSocial/ReportButton';
import FacebookButton from 'src/modules/shared/components/buttons/FacebookButton';
import CopyLinkButton from 'src/modules/shared/components/buttons/CopyLinkButton';
import LikeButton from 'src/modules/shared/components/buttons/LikeButton';
import ChangeSizeButton from 'src/modules/shared/components/buttons/ChangeSizeButton';

import styles from './style.module.scss';
interface IProps extends IContent {
    text?: string;
}

export function ContentMoreAction(props: IProps) {
    const { Modal, show, hide } = useModal({ fromBottom: true });
    const isMiniapp = useSelector(isMiniappSelector);
    const isOpen = useSelector(isOpenSelector);
    const { url, shareUrl, title, publisher, contentId, text = '' } = props;
    const handleClickShare = () => {
        show();
    };

    const handleClick = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <>
            <IconButton
                title={text}
                text={text}
                icon="new-more-light"
                onClick={handleClickShare}
                className={twMerge(
                    'inline-flex items-center',
                    'text-[13px] text-[#000]',
                    'leading-[1]',
                    'p-[6px]',
                    cn({
                        'p-0 ml-[8px] text-[#666] font-semibold': !isOpen,
                    }),
                )}
                classNameIcon={
                    isOpen
                        ? 'text-[24px]'
                        : 'p-[4px] text-[20px] text-[#999] bg-[rgba(0,0,0,0.05)] rounded-full'
                }
            />

            <Modal
                className={cn(
                    styles['more-modal'],
                    'w-full h-full',
                    'm-0 px-[15px]',
                    'bg-transparent',
                )}
            >
                <Element onClick={handleClick}>
                    <Element
                        className={cn(
                            'text-[20px] text-[#4D4D4D] text-center',
                            'font-[800]',
                            'py-[12px] m-[0_20px_8px]',
                            'border-b border-solid border-[#F0F0F0]',
                        )}
                    >
                        Công cụ
                    </Element>
                    <Element>
                        {!isMiniapp && !isOpen && (
                            <FacebookButton
                                className={cn(
                                    'px-[15px]',
                                    'flex items-center',
                                    'w-full',
                                    'text-left',
                                    'text-[16px] py-[12px]',
                                    'leading-[1]',
                                )}
                                hide={hide}
                                link={shareUrl}
                                title={title}
                            >
                                <Icon
                                    className={cn(
                                        'flex justify-center',
                                        'w-[36px]',
                                        'text-[24px]',
                                        'mr-[10px]',
                                        'box-content',
                                    )}
                                    icon="new-facebook-solid"
                                />
                                <Element renderAs="span">Chia sẻ</Element>
                            </FacebookButton>
                        )}
                        {!isOpen && (
                            <CopyLinkButton
                                className={cn(
                                    'px-[15px]',
                                    'flex items-center',
                                    'w-full',
                                    'text-left',
                                    'text-[16px] py-[12px]',
                                    'leading-[1]',
                                )}
                                classNameIcon={cn(
                                    'flex justify-center',
                                    'w-[36px]',
                                    'text-[28px]',
                                    'mr-[10px]',
                                    'box-content',
                                )}
                                link={url}
                                hide={hide}
                            />
                        )}
                        <ChangeSizeButton />
                        <LikeButton
                            contentId={contentId}
                            className={cn(
                                'px-[15px]',
                                'flex items-center',
                                'w-full',
                                'text-left',
                                'text-[16px] py-[12px]',
                                'leading-[1]',
                            )}
                            classNameIcon={cn(
                                'flex justify-center',
                                'w-[36px]',
                                'text-[28px]',
                                'mr-[10px]',
                                'box-content',
                            )}
                            classIconLike={cn(
                                'flex justify-center',
                                'w-[36px]',
                                'text-[28px] text-[var(--primary)]',
                                'mr-[10px]',
                                'box-content',
                            )}
                        />

                        {publisher && (
                            <FollowButton
                                title={`Theo dõi "${publisher.shortName}"`}
                                titleFollow={`"${publisher.shortName}" đã được theo dõi`}
                                objectType={OBJECT_TYPE.PUBLISHER}
                                objectId={publisher.id}
                                className={cn(
                                    'px-[15px]',
                                    'flex items-center',
                                    'w-full',
                                    'text-left',
                                    'text-[16px] py-[12px]',
                                    'leading-[1]',
                                )}
                                icon="new-plus-regular"
                                iconFollow="new-check-circle-solid"
                                classIcon={cn(
                                    'flex justify-center',
                                    'w-[36px]',
                                    'text-[24px]',
                                    'mr-[10px]',
                                    'box-content',
                                )}
                                classIconFollow={cn(
                                    'flex justify-center',
                                    'w-[36px]',
                                    'text-[24px] text-[var(--primary)]',
                                    'mr-[10px]',
                                    'box-content',
                                )}
                            />
                        )}

                        <BookmarkButton
                            contentId={contentId}
                            className={cn(
                                'px-[15px]',
                                'flex items-center',
                                'w-full',
                                'text-left',
                                'text-[16px] py-[12px]',
                                'leading-[1]',
                            )}
                            classNameIcon={cn(
                                'flex justify-center',
                                'w-[36px]',
                                'text-[28px]',
                                'mr-[10px]',
                                'box-content',
                            )}
                            classIconBookmark={cn(
                                'flex justify-center',
                                'w-[36px]',
                                'text-[28px] text-[var(--primary)]',
                                'mr-[10px]',
                                'box-content',
                            )}
                        />

                        <ReportButton
                            contentId={contentId}
                            className={cn(
                                'px-[15px]',
                                'flex items-center',
                                'w-full',
                                'text-left',
                                'text-[16px] py-[12px]',
                                'leading-[1]',
                            )}
                            classNameIcon={cn(
                                'flex justify-center',
                                'w-[36px]',
                                'text-[28px]',
                                'mr-[10px]',
                                'box-content',
                            )}
                        />

                        <Element
                            title="Đóng"
                            className={cn(
                                'flex items-center justify-center',
                                'py-[12px] m-[10px_20px_0]',
                                'text-[20px] font-[800] text-[#4D4D4D]',
                                'border-t border-solid border-[#F0F0F0]',
                            )}
                            onClick={hide}
                        >
                            Đóng
                        </Element>
                    </Element>
                </Element>
            </Modal>
        </>
    );
}

export default memo(ContentMoreAction);
